export default class HazardPerceptions {
    rootElement: HTMLElement;
    videoElement: HTMLVideoElement;
    overlayElement: HTMLElement;
    playButton: HTMLButtonElement;
    actionButton: HTMLButtonElement;
    successMessage: HTMLElement;
    failEarlyMessage: HTMLElement;
    failLateMessage: HTMLElement;
    failNoAttemptMessage: HTMLElement;
    failNotRequiredMessage: HTMLElement;
    descriptionMessage: HTMLElement;
    actionClicked: boolean;

    constructor(private uniqueID: string, private timeStart: number = -1, private timeEnd: number = -1) {
        this.rootElement = document.getElementById(this.uniqueID);
        if (!this.rootElement) return;

        this.initialiseElements();
        this.initialiseComponent();
    }

    private initialiseElements() {
        this.videoElement = this.rootElement.querySelector<HTMLVideoElement>('.hp-video video');
        this.overlayElement = this.rootElement.querySelector('.hp-video-overlay');
        this.playButton = this.rootElement.querySelector<HTMLButtonElement>('.hp-control-buttons .play-button .button');
        this.actionButton = this.rootElement.querySelector<HTMLButtonElement>('.hp-control-buttons .action-button .button');
        this.descriptionMessage = this.rootElement.querySelector('.hp-description');
        this.successMessage = this.rootElement.querySelector('.hp-success');
        this.failEarlyMessage = this.rootElement.querySelector('.hp-fail-early');
        this.failLateMessage = this.rootElement.querySelector('.hp-fail-late');
        this.failNoAttemptMessage = this.rootElement.querySelector('.hp-fail-noattempt');
        this.failNotRequiredMessage = this.rootElement.querySelector('.hp-fail-notrequired');
    }

    private initialiseComponent() {
        if (!this.videoElement) return;
        this.actionClicked = false;

        this.videoElement.pause();
        this.overlayElement.classList.remove('d-none');

        this.playButton?.addEventListener('click', (event) => this.startVideo(event));
        this.actionButton?.addEventListener('click', (event) => this.handleAction(event));

        this.videoElement.addEventListener('play', () => this.updateButtonStates());
        this.videoElement.addEventListener('pause', () => this.updateButtonStates());
        this.videoElement.addEventListener('ended', () => this.handleVideoEnd());

        this.updateButtonStates();
    }

    private updateButtonStates() {
        if (this.videoElement.paused) {
            this.actionButton.classList.add('disabled');
            this.actionButton.disabled = true;
            this.playButton.classList.remove('disabled');
            this.playButton.disabled = false;

        } else {
            this.actionButton.classList.remove('disabled');
            this.actionButton.disabled = false;

            this.playButton.classList.add('disabled');
            this.playButton.disabled = true;
        }
    }

    private startVideo(event: Event) {
        event.preventDefault();
        this.playButton.setAttribute('aria-pressed', 'true');
        this.actionButton.setAttribute('aria-pressed', 'false');

        this.resetMessages();
        this.videoElement.currentTime = 0;
        this.videoElement.play();
        this.overlayElement.classList.add('d-none');
        this.descriptionMessage?.classList.add('d-none');
        this.actionClicked = false;
    }

    private handleAction(event: Event) {
        event.preventDefault();
        this.playButton.setAttribute('aria-pressed', 'false');
        this.actionButton.setAttribute('aria-pressed', 'true');
        const currentTime = this.videoElement.currentTime;

        if (this.timeStart < 0 && this.timeEnd < 0) {
            this.showMessage(this.failNotRequiredMessage);
            this.videoElement.pause();
            this.overlayElement.classList.remove('d-none');
            return;
        }

        this.videoElement.pause();
        this.overlayElement.classList.remove('d-none');

        if (this.timeStart >= 0 && this.timeEnd >= 0) {
            if (currentTime >= this.timeStart && currentTime <= this.timeEnd) {
                this.showMessage(this.successMessage);
            } else if (currentTime < this.timeStart) {
                this.showMessage(this.failEarlyMessage);
            } else if (currentTime > this.timeEnd) {
                this.showMessage(this.failLateMessage);
            }
        } else {
            this.showMessage(this.successMessage);
        }

        this.actionClicked = true;
    }

    private handleVideoEnd() {
        this.playButton.setAttribute('aria-pressed', 'false');

        this.updateButtonStates();
        this.overlayElement.classList.remove('d-none');

        if (this.timeStart >= 0 && this.timeEnd >= 0 && !this.actionClicked) {
            this.showMessage(this.failNoAttemptMessage);
        } else {
            this.showMessage(this.successMessage);
        }
    }

    private resetMessages() {
        this.successMessage?.classList.add('d-none');
        this.failEarlyMessage?.classList.add('d-none');
        this.failLateMessage?.classList.add('d-none');
        this.failNoAttemptMessage?.classList.add('d-none');
        this.failNotRequiredMessage?.classList.add('d-none');
    }

    private showMessage(messageElement: HTMLElement) {
        this.resetMessages();
        if (messageElement)
            messageElement.classList.remove('d-none');
    }
}
